import { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import InputConfig from '../../../../../Components/InputConfig';

//mui imports====
import useCommonStyles from '../../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
import PageHeading from '../../../../../Components/PageHeading';

//===============

const CustomFloatConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Custom Float"
				headingPath={['Dashboard', 'Framerate', 'Format Data', 'Custom Float']}
				description="Float the player with custom query selector"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid
				container
				spacing={1}
				style={{ width: '90%', paddingBottom: '3rem', marginLeft: '4rem', marginTop: '3rem' }}
			>
				<Grid item xs={3}>
					<CheckBoxInput
						keyData={keyData + '.enabled'}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ marginTop: '5rem', width: 'fit-content' }}
					/>
				</Grid>
				<Grid item xs={8} style={{ marginLeft: '-5rem' }}>
					<InputConfig
						label="Query Selector"
						keyData={keyData + '.querySelector'}
						inputType="text"
						object={rawConfig}
						editable={!!rawConfig[keyData + '.enabled']}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default CustomFloatConfig;
